const INTERNAL_PARAM = "internal";

// Chrome's maximum cookie lifetime. A longer Max-Age is capped to this anyway.
const FOUR_HUNDRED_DAYS_SECONDS = 60 * 60 * 24 * 400;

const hasInternalQueryParam = () =>
  new URLSearchParams(window.location.search).has(INTERNAL_PARAM);

const hasInternalCookie = () =>
  document.cookie.split(";").some((part) => part.trim().split("=")[0] === INTERNAL_PARAM);

const setInternalCookie = () => {
  document.cookie = `${INTERNAL_PARAM}=1; Path=/; Max-Age=${FOUR_HUNDRED_DAYS_SECONDS}`;
};

/** Internal mode is on when `?internal` is present, otherwise when the persistent cookie is set. */
export const isInternalMode = () => {
  if (hasInternalQueryParam()) {
    setInternalCookie();
    return true;
  }

  return hasInternalCookie();
};
